import React, {Component} from "react";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {SafeImage} from "../../components/Shared/SafeImage";
import {formsCheckboxUpdater, formsUpdater, getFormFieldValue} from "../Applications/shared/shared";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {deleteData, getData, postData} from "../../api/doLogin";
import {ConfirmDialog} from "../../components/Shared/ConfirmDialog";
import {ReplaceableImageWrapper} from "../../components/Shared/ReplaceableImageWrapper";
import {toast} from "react-toastify";
import {TrainingVideoPlayer} from "../../components/Shared/VideoPlayer";

export default class TrainingItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      categories: [],
      formData: {},
      editMode: false,
      shouldDelete: false,
      working: false,
    }
  }

  closeMe() {
    this.cancelEdit();
    this.props.onClose && this.props.onClose();
  }

  cancelEdit() {
    this.setState({editMode: false, formData: {}, shouldDelete: false})
  }

  deleteMe() {
    this.setState({shouldDelete: true})
  }

  removeItem() {
    const self = this;
    deleteData(`training/file/${this.props.training.id || 0}`, {}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.props.onUpdate();
          self.closeMe();
        } else {
          console.error(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  conditionCheckedInt(evt) {
    const target = {id: evt.target.id, checked: evt.target.checked ? 1 : 0};
    return {target};
  }

  getFile() {
    const self = this;
    getData(`training/file/${this.props.training.id || 0}`, {}, this.props.token)
      .then((data) => {
        if (data && data.data && data.data.url) {
          window.location = data.data.url;
        }
      })
      .catch(error => {
        console.error(error);
        toast.error("Cannot get file");
      });
  }

  saveForm() {
    const formData = this.state.formData;
    formData.category = Number(formData.category);
    const self = this;
    postData(`training/${this.props.training.id || 0}/edit`, {...formData}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.props.onUpdate({...formData});
          self.closeMe();
        } else {
          console.error(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  render() {
    const training = this.props.training || {};
    let categoryDisplay = this.props.categories.find((cat) => cat.id === training.category);
    let typeTraining = this.state.formData.type || training.type || "";
    let isVideo = typeTraining.startsWith("video/");
    return (
      <MakeDialog isOpen={!!this.props.training}
                  headerTag={"div"}
                  header={
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      {!this.state.editMode ?
                        <h4>{training.title}</h4>
                        :
                        <Input
                          type="text"
                          id="title"
                          style={{width: 300, display: "inline"}}
                          value={getFormFieldValue(this.state.formData['title'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      }
                      <span style={{display: "flex", fontSize: 11}}>
                          <Button color="secondary"
                                  disabled={this.state.working}
                                  onClick={() => this.closeMe()}>Close</Button>
                    </span>
                    </div>
                  }
                  footer={
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      {this.state.editMode ?
                        <React.Fragment>
                          <Button color="success"
                                  disabled={this.state.working}
                                  onClick={() => this.saveForm()}>Save</Button>
                          <Button color="secondary"
                                  disabled={this.state.working}
                                  onClick={() => this.cancelEdit()}>Cancel</Button>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          {hasPermission(RequiredPermission.TrainingEdit) && (<Button color="primary"
                                                                                      onClick={() => this.setState({
                                                                                        editMode: true,
                                                                                        formData: training
                                                                                      })}>Edit</Button>)}
                          {hasPermission(RequiredPermission.TrainingRemove) && (<Button color="danger"
                                                                                        onClick={() => this.deleteMe()}>Remove</Button>)}
                        </React.Fragment>
                      }
                      <Button color="secondary"
                              disabled={this.state.working}
                              onClick={() => this.closeMe()}>Close</Button>
                    </div>
                  }
      >
        <Row>
          <Col xs={12} sm={12}>
            {hasPermission(RequiredPermission.TrainingEdit) && (
              <div>
                <FormGroup className={"form-group-condensed"}>
                  <Label for="category">Category</Label>
                  {this.state.editMode ?
                    <Input
                      type="select"
                      id="category"
                      style={{width: 300, display: "inline", marginLeft: 5}}
                      value={getFormFieldValue(this.state.formData['category'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    >
                      <option key={0} disabled={true} value={""}>Please Choose</option>
                      {this.props.categories.map((category, index) => {
                        return (
                          <option key={index} value={Number(category.id)}>{category.display}</option>
                        )
                      })}
                    </Input>
                    :
                    <span>:&nbsp;{categoryDisplay && categoryDisplay.display || "Edit to Choose"}</span>
                  }
                </FormGroup>
                <span>
              Visible&nbsp;&nbsp;&nbsp;
                  <Label className="switch switch-text switch-primary">
                  <Input type="checkbox"
                         id={"visible"}
                         className="switch-input"
                         checked={!this.state.editMode ? training.visible === 1 : this.state.formData.visible === 1}
                         onChange={(evt) => formsCheckboxUpdater(this.conditionCheckedInt(evt), this.state['formData'], this)}
                         disabled={!this.state.editMode}/>
                  <span className="switch-label" data-on="yes" data-off="no"></span>
                  <span className="switch-handle"></span>
                </Label>
              </span>
              </div>
            )}
            <div>
              <ReplaceableImageWrapper
                canReplace={hasPermission(RequiredPermission.TrainingEdit) && this.state.editMode}
                uploadURL={`training/file/${training.id}`}
                acceptedMimes={['application/pdf', 'video/mp4']}
                //, 'image/jpeg', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/zip'
                appendFormData={[{name: "action", value: "UploadFile"}]}
                limit={1}
                onUpload={() => this.setState({working: true})}
                onComplete={() => this.setState({working: false})}
                onReplace={(url, cb) => this.setState({
                  formData: {
                    ...this.state.formData,
                    url: `${url[0].previewURL}`,
                    processed: url[0].processed,
                    type: url[0].mime
                  }
                })}
              >
                {isVideo ?
                  <TrainingVideoPlayer src={training.id}/>
                  :
                  <SafeImage src={this.state.formData.url || training.url || ""} width={400} height={"auto"}/>
                }
              </ReplaceableImageWrapper>
            </div>
            {training && training.duration !== 0 && (
              <div
                style={{
                  display: "block",
                  fontWeight: "bold"
                }}>
                Duration: {this.state.editMode ? getFormFieldValue(this.state.formData['duration']) : training.duration}sec
              </div>
            )}

            {!this.state.editMode ?
              <pre style={{whiteSpace: "pre-wrap"}}>{training.notes}</pre>
              :
              <Input
                type="textarea"
                id="notes"
                rows={10}
                // autoFocus
                style={{fontSize: 12}}
                value={getFormFieldValue(this.state.formData['notes'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            }
            {typeTraining.length > 0 && !isVideo && (
              <div>
                <Button color="secondary"
                        disabled={this.state.working}
                        onClick={() => this.getFile()}>Download</Button>
              </div>
            )}

          </Col>
        </Row>

        {this.state.shouldDelete && (
          <ConfirmDialog isOpen={true}
                         onOk={() => this.removeItem()}
                         onCancel={() => this.cancelEdit()}
          >
            <div>Are you sure you want to delete this training item?</div>
          </ConfirmDialog>
        )}

      </MakeDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Training/TrainingItem.js